import { Injectable } from '@angular/core';
import { MENU } from 'src/settings/menu';
import { Subject, Observable, timer } from 'rxjs';
import { takeUntil, switchMap } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment.prod'
declare var globalConfig: any;
@Injectable()
export class GlobalService {
  static spinner;
  static user: any;
  static subscription: any;
  static ajaxSubscription: any = [];
  static title;
  static blocka = "hxdXHn1O";
  static blockb = "izG8zRwU";
  static blockc = "2M2g3sN7";
  static blockd = "Q9Xr1mPi";
  private static _titleObserver = new Subject();
  static titleObservable = GlobalService._titleObserver.asObservable();
  // private timer$ = timer(0, 1000); // Timer that ticks every second
  // private activity$ = new Subject<void>();
  private destroy$ = new Subject<void>();
  constructor(private as: AuthService) {
    // this.resetTimer();

    // // Subscribe to user activity events
    // this.activity$.subscribe(() => this.resetTimer());
  }
  static changeTitle(newTitle: string) {
    let that = this;
    setTimeout(function () {
      that.title = newTitle;
      that._titleObserver.next(newTitle);
    }, 100);
  }

  static getMenuItemByPath(path: string) {
    path = path.split('?')[0];

    for (let item of MENU) {
      if (item.path == path)
        return item;
      if (item.sub) {
        for (let subItem of item.sub) {
          if (subItem.path == path)
            return subItem;
        }
      }
    }
  }


  decryptData(encrypted: string): any {
    const key = GlobalService.blocka + GlobalService.blockb + GlobalService.blockc + GlobalService.blockd;
    let cipherBytes = CryptoJS.enc.Base64.parse(encrypted); // Convert Base64 string to WordArray
    // Extract IV from the cipherBytes (first 16 bytes)
    let iv = cipherBytes.words.slice(0, 4); // IV length is 16 bytes, each word is 4 bytes
    // Remaining words are ciphertext
    let encryptedData = cipherBytes.words.slice(4);
    // Convert IV and ciphertext to WordArray
    let ivWordArray = CryptoJS.lib.WordArray.create(iv);
    let encryptedDataWordArray = CryptoJS.lib.WordArray.create(encryptedData);

    let decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedDataWordArray },
      CryptoJS.enc.Utf8.parse(key),
      { iv: ivWordArray }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  encryptData(data: any): any {
    const key = GlobalService.blocka + GlobalService.blockb + GlobalService.blockc + GlobalService.blockd;
    let iv = CryptoJS.lib.WordArray.random(16); // Generate a random IV
    let encrypted = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(key), { iv: iv });
    return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
  }


  static getMenuItemByPathwithRole(path: string, role: String) {
    path = path.split('?')[0];

    for (let item of MENU) {
      if (item.path == path && item.role == role)
        return item;
      if (item.sub) {
        for (let subItem of item.sub) {
          if (subItem.path == path && subItem.role == role)
            return subItem;
        }
      }
    }
  }
  startTimeout(timeoutInSeconds: number): Observable<void> {
    return timer(timeoutInSeconds * 1000).pipe(
      switchMap(() => this.as.logout()),
      takeUntil(this.destroy$)
    );
  }

  resetTimeout(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.destroy$ = new Subject<void>();
  }

  static userdata() {
    if (localStorage.user && localStorage.user != "") {
      return true
    }
    else
      return false

  }
  static getPageTitleByPath(path: string) {
    path = path.split('?')[0];
    let item = this.getMenuItemByPath(path);
    return item.title;
  }

  static unsubscribeAjax() {
    for (let i = 0; i < this.ajaxSubscription.length; i++) {
      if (this.ajaxSubscription[i])
        this.ajaxSubscription[i].unsubscribe();
    }
    this.ajaxSubscription = [];
  }

  static unsubscribe() {
    if (this.subscription)
      this.subscription.unsubscribe();

    this.unsubscribeAjax();
  }
  static getNameCSV(list) {
    if (list && list.length > 0) {
      return list.map(function (k) { return k["Name"] }).join(",");
    }
    else
      return "";
  }

  // -------- Input validation helpers (VAPT: block meta/special chars used for XSS) --------
  static hasUnsafeInput(value: any): boolean {
    if (value === null || value === undefined) return false;
    if (typeof value !== 'string') return false;
    const s = value.trim();
    if (!s) return false;

    // Block HTML/meta characters and common script URL vectors.
    return /[<>]/.test(s) || /javascript:/i.test(s) || /data:text\/html/i.test(s);
  }

  static isLengthInRange(value: any, min: number, max: number): boolean {
    if (value === null || value === undefined) return min === 0;
    const s = String(value);
    return s.length >= min && s.length <= max;
  }

  static safeTrim(value: any): any {
    if (value === null || value === undefined) return value;
    if (typeof value !== 'string') return value;
    return value.trim();
  }
}
